import { useCallback, useEffect, useState } from 'react';
import { listEditorVideos } from '../api/videoEditor.api';

/**
 * Single source for the editor's video list, shared by the "Creados" tab and
 * the thumbnails carousel so the list is fetched once, not once per consumer.
 */
const useEditorVideos = (ftpUser) => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await listEditorVideos(ftpUser);
      setJobs(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error fetching editor videos:', err);
      setError('No se pudo cargar el listado de videos creados.');
    } finally {
      setLoading(false);
    }
  }, [ftpUser]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { jobs, loading, error, refresh };
};

export default useEditorVideos;
